import React, { useState } from "react";
import DictExercisesService from "../../../services/dict/DictExercisesService";
import { withTranslation } from "react-i18next";
import Modal from "../../../constants/Modal";

type Props = {
    item: string;
    dict: string;
    onDeleteExercise: (id: string) => void;
    onEditExercise: (exerciseId: string, dict: string) => void;
    t: any;
};

const Options: React.FC<Props> = ({ item, dict, onDeleteExercise, onEditExercise, t }) => {
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const openOptionsModal = () => {
        setModalTitle(t("modals.optionsTitle"));
        setShowModal(true);
    };

    const deleteExercise = (itemId: string) => {
        DictExercisesService.deleteDictExercise(itemId)
            .then(() => {
                onDeleteExercise(itemId);
                setShowModal(false);
            })
            .catch(error => {
                console.error('Error deleting exercise:', error);
            });
    };

    return (
        <div>
            <img src="/images/navigation/options.svg" alt="Options" style={{ cursor: "pointer", width: "24px", height: "24px" }} onClick={openOptionsModal} />

            <Modal show={showModal} onClose={() => setShowModal(false)} title={t("table.options")}>
                <div>
                    <div>
                        <button onClick={() => deleteExercise(item)} className="buttonDelete">
                            {t("buttons.delete")}
                        </button>
                        <p>{t("buttons.delete_exercise_description")}<br /><br /></p>
                    </div>

                    <div>
                        <button onClick={() => { onEditExercise(item, dict); setShowModal(false); }}>
                            {t("buttons.edit")}
                        </button>
                        {/* <p>{t("buttons.edit_description")}<br /><br /></p> */}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default withTranslation("global")(Options);
